// extracted by mini-css-extract-plugin
module.exports = {"btnNew":"filter_btnNew__13_uL","btnFilter":"filter_btnFilter__23zZN"};